export default __webpack_public_path__ + "static/media/heroku.5c9b3c2c.svg";